import { render } from "./ClientManagerDashboard.vue?vue&type=template&id=e6dc4dfc&scoped=true"
import script from "./ClientManagerDashboard.vue?vue&type=script&lang=js"
export * from "./ClientManagerDashboard.vue?vue&type=script&lang=js"

import "./ClientManagerDashboard.vue?vue&type=style&index=0&id=e6dc4dfc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6dc4dfc"]])

export default __exports__